/**
 * Old → new route redirects for the 53c IA rewrite.
 *
 * Keys are the old paths (live before 53c). Values are the new paths.
 * The redirect set is rendered as <Navigate> components in App.tsx so
 * external bookmarks and Slack permalinks don't break when the IA
 * reshuffles in 53c.
 *
 * When a section's IA settles, leave the redirect entry in place — it
 * costs nothing and keeps third-party links stable.
 */
export const ROUTE_REDIRECTS: Record<string, string> = {
  '/organisations': '/orgs',
  '/projects': '/orgs', // Projects fold into Org Detail tab in 53c.2
  '/applications': '/signup-queue',
  '/blocklist': '/signup-queue/blocklist',
  '/pricing-plans': '/catalog/plans',
  '/features': '/catalog/features',
  '/calculator': '/catalog/calculator',
  '/admin-users': '/access/users',
  '/partners': '/access/partners',
  '/logs': '/ops/logs',
  '/status': '/ops/status',
};
